import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MetamaskConnectService } from '../../blockchainUtils/metamask-connect.service';
import { ParticipationTokenInstanceService } from 'app/blockchainUtils/participation-token-instance.service';
import Web3 from 'web3';

@Component({
  selector: 'app-sell-modal',
  templateUrl: './sell-modal.component.html',
  styleUrls: ['./sell-modal.component.scss']
})
export class SellModalComponent implements OnInit {

  @Input() poolTokenAddress: string = '';
  @Input() asset: any;

  amount: number = 0;
  availableTokens: number = 0;
  availablePercent: number = 0;
  web3: any;
  salePercent: number = 0;
  inputMax: number = 0;
  inputMin: number = 0.1;
  participationTokensMinted: number = 100;

  loading: boolean = true;
  error: any = {
    status: true,
    message: ''
  };

  constructor(
    private modalService: NgbActiveModal,
    private participationTokenService: ParticipationTokenInstanceService,
    private connectWallet: MetamaskConnectService,
  ) { }

  ngOnInit(): void {
    this.getUserTokensAvailable();
  }

  async getUserTokensAvailable() {
    await this.connectWallet
      .connectWallet( window )
      .catch( err => console.log( err ) );
    this.web3 = this.connectWallet.web3;

    const poolTokenInstance = await this.participationTokenService.instantiate( this.web3, this.poolTokenAddress );

    let userAddress = '';
    await this.web3.eth.getAccounts().then( ( accounts) => {
      userAddress = accounts[0];
      console.log( userAddress )
    });

    await poolTokenInstance.methods.balanceOf( userAddress ).call( (err, res) => {
      if( err ) {
        console.log( err );
        return;
      }
      this.availableTokens = Number( Web3.utils.fromWei( res ) );
      this.inputMax = this.availableTokens * 100 / this.participationTokensMinted;
      this.availablePercent = this.inputMax;

      console.log('availableTokens', this.availableTokens, 'input', this.inputMax, 'available percent',this.availablePercent);

      this.loading = false;
    } );
  } 

  //TODO RECORDAR AL USUARIO QUE SI VENDE TODOS LOS TOKENS DISPONIBLE EL SE VA A QUEDAR SIN PARTICIPACIÓN
  onChangeAmount( event: any ) {

    console.log('typeof', typeof event.target.value );
    console.log('number', Number( event.target.value ), this.inputMin, Number( event.target.value ) % this.inputMin);
    if( event.target.value < 0 ){
      event.target.value = 0;
      this.error.status = false;
    }else if( Number( event.target.value ) > this.inputMax ){
      this.error = {
        status: true,
        message: `The amount can't be greater than available tokens`
      };
    }else if( Number( event.target.value )*10 % 1 !== 0 ){
      this.error = {
        status: true,
        message: `The amount must be a multiple of ${this.inputMin}%`
      };
    }
    else{
      this.error.status = false;
      this.salePercent = event.target.value.length > 0 
                            ? Number( event.target.value )
                            : 0;
      this.amount = this.salePercent * this.availableTokens / 100;
      console.log('amount', this.amount);
    }

  }

  listForSale() {
    this.modalService.close( this.amount !== 0 ? this.amount : null );
  }

  convertFromWei( num: any ) {
    return this.web3.utils.fromWei( num );
  }

  close() {
    this.modalService.close( null );
  }

}
